const EntityListPreferencesDefaults = {
  initialEntityCount: 0
};
export {
  EntityListPreferencesDefaults
};
//# sourceMappingURL=EntityListPreferences.js.map
